import React, { useEffect, useState } from "react";
import { EaseDrawer } from "../../libs/EaseDrawer";
import { Text1, Text3, Text5, Text4 } from "../../styles";
import { Descriptions, Button, Badge, Tooltip, Spin, Icon, Popconfirm } from "antd";
import { handleApiExceptions, printRupee, alertify, getObjectFromArray } from "../../app_methods";
import { VirtualAccount, SmartCollectTransactionOrders } from '../../models';
import { SMART_COLLECT_TRANSACTION_ORDERS_STATUS_TYPES, SMART_COLLECT_TRANSACTION_ORDERS_NOTIFICATION_CYCLE_TYPES } from "../../constants";
import moment from 'moment';
import { PermissionHoc } from '../HOC';


const OrderDetailsDrawer = (props) => {
    const current_user = props.current_user || {};
    const  [order, setOrder] = useState({});
    const triggerWebhook = getObjectFromArray(current_user?.instacollect_webhook_settings|| [], "event_name", "ORDER_STATUS_UPDATE") || {};
    const [virtualAccountObj, setVirtualAccountObj] = useState({});
    const [isRequesting, setIsRequesting] = useState(false);
    const [isSendingNotification, setIsSendingNotification] = useState(false);
    const [isCancelling, setIsCancelling] = useState(false);
    const [isReTriggeringWebHook, setIsReTriggeringWebHook] = useState(false);

     useEffect(() => {
        retrieveOrder()
     }, [props.order])
     
   
    const PermissableButton = PermissionHoc(Button, null, { is_component: true, fallbackComponent: null })


    const notify_customer = () => {
        setIsSendingNotification(true);
        SmartCollectTransactionOrders.notify_customer(order).then(response => {
            if (response.success) alertify("Success", `Notification sent to the customer.`, "success");
            setIsSendingNotification(false);
        }).catch(error => {
            handleApiExceptions(error);
            return;
        })
    }

    const retrieveOrder = () => {
        SmartCollectTransactionOrders.fetchOrder(props.order.id, {is_submerchant:props.order.is_submerchant}).then(response => {
            if (response.success) {
                setOrder(response?.data?.transaction_order);
                setVirtualAccountObj(response?.data?.transaction_order?.virtual_account);
            }
        }).catch(error => {
            handleApiExceptions(error);
            return;
        })
    }

    const cancel = async (values) => {
        setIsCancelling(true);
        const cancel_order = new SmartCollectTransactionOrders(values);
        const response = await cancel_order.cancel()
        if (!response.success) {
            setIsCancelling(false);
            handleApiExceptions(response);
            return;
        }
        alertify("Success", "Order cancelled successfully.", "success");
        setIsCancelling(false);
        props.fetchTransactionOrdersData();
        retrieveOrder();
    }

    const reTriggerWebhook = async (id) => {
        setIsReTriggeringWebHook(true);
        const transaction_order = new SmartCollectTransactionOrders({'id': id});
        const response = await transaction_order.retrigger_webhook();
        if (!response.success) {
            setIsReTriggeringWebHook(false);
            handleApiExceptions(response);
            return;
        }
        let message = response.data.message;
        alertify("Success", message, "success");
        setIsReTriggeringWebHook(false);
    }

    const renderDetails = () => {
        return (
            <Descriptions className="mb-4" title="" column={1} size="small" bordered>
                <Descriptions.Item label="Account Name">{current_user?.name || '---'}</Descriptions.Item>
                {virtualAccountObj.account_number ? <Descriptions.Item label="A/C Number / IFSC ">
                    <div className="mb-1"> {virtualAccountObj.account_number || "---"} </div>
                    <div> {virtualAccountObj.ifsc || "---"} </div>
                </Descriptions.Item> : null }
                {virtualAccountObj.upi_handle ? <Descriptions.Item label="UPI Handle">{virtualAccountObj.upi_handle || "---"}</Descriptions.Item> : null}
                {virtualAccountObj.upi_qrcode_url ? <Descriptions.Item className={'d-flex flex-column align-items-start'} label="UPI QR"><img style={{ maxWidth: 150 }} src={virtualAccountObj.upi_qrcode_url} />
                </Descriptions.Item> : null}
                <Descriptions.Item label="Status">{
                    <Badge color={virtualAccountObj.is_active ? 'green' : 'red'} text={<Text3>{virtualAccountObj.is_active ? 'Active' : 'Inactive'}</Text3>} />
                }</Descriptions.Item>
            </Descriptions>
        )
    };
    
    return (
        <EaseDrawer
            className="payout-link-details-drawer"
            visible={props.visible}
            onOpen={() => retrieveOrder()}
            onClose={props.onClose}
            hideHeader
            hideFooter
            width={525}
        >
            {
            isRequesting ?
                <div style={{ width: "100%", height: "84vh" }} className="d-flex justify-content-center align-items-center">
                    <Spin className="mt-4" tip="Loading..." spinning={isRequesting} />
                </div>
                :
                <div className="mt-3">
                    <div className="mb-4">
                        <Text1 className="d-block" strong>Order Details</Text1>
                        <Text5 copyable>{order.id}</Text5>
                    </div>

                    <div className="d-flex mb-2 justify-content-end">
                    {
                   
                    [0,1].includes(order.status) ? 
                        <div className="w-100 d-flex justify-content-end">
                            <PermissableButton required_permission={"IC_ORDER_WRITE"} onClick={notify_customer} loading={isSendingNotification} icon="bell" disabled={order.is_submerchant} size="small">Notify Customer</PermissableButton>
                        </div>
                    : null }
                    
                    {
                        (current_user?.smart_collect_virtual_account_settings?.notification_settings?.webhook_enabled && triggerWebhook?.is_enable && !props.order.is_submerchant) && 
                            <PermissableButton required_permission="IC_ORDER_WRITE" className='ml-2' icon='code' loading={isReTriggeringWebHook} onClick={() => reTriggerWebhook(order.id)} size="small"> Trigger Webhook </PermissableButton>
                    }
                    </div>
                    <Descriptions className="mt-2" title={false} column={1} bordered size="small">
                        <Descriptions.Item label="Unique Request Number">{order.merchant_request_number}</Descriptions.Item>
                        <Descriptions.Item label="Amount">{printRupee(order.amount, 2)}</Descriptions.Item>
                        { order.per_transaction_amount ? 
                            <Descriptions.Item label="Per Transaction Amount">{printRupee(order.per_transaction_amount, 2)}</Descriptions.Item>
                        : null}
                        <Descriptions.Item label="Received Amount">{printRupee(order.received_amount, 2)}</Descriptions.Item>
                        { order.notification_cycle_type  ? 
                            <Descriptions.Item label="Notification Cycle" >{SMART_COLLECT_TRANSACTION_ORDERS_NOTIFICATION_CYCLE_TYPES[order.notification_cycle_type].label}</Descriptions.Item>
                        : null}
                        { order.expiry_date  ? 
                            <Descriptions.Item label="Expiry Date" >{order.expiry_date && moment(order.expiry_date).format("LLL")}</Descriptions.Item>
                        : null}
                        
                        {
                        order.status !=undefined?
                        <Descriptions.Item label="Status">
                        <div className="w-100 d-flex justify-content-between align-items-center">
                            <Badge color={SMART_COLLECT_TRANSACTION_ORDERS_STATUS_TYPES[order.status].color}
                            text={<Text4>{SMART_COLLECT_TRANSACTION_ORDERS_STATUS_TYPES[order.status].label}</Text4>}/>
                            {
                                [0,1].includes(order.status) ? 
                                <Popconfirm title="Are you sure you want to cancel this transaction order?" okText="Yes" cancelText="No" onConfirm={() => cancel(order)}>
                                <PermissableButton required_permission="IC_ORDER_WRITE" size="small" type="danger" disabled={order.status == 'cancelled'}ghost loading={isCancelling}>Cancel</PermissableButton>
                                </Popconfirm> : null
                            }
                        </div>
                        </Descriptions.Item>
                        :
                        null }
                        <Descriptions.Item label="Customer Name">{order.customer_name}</Descriptions.Item>
                        <Descriptions.Item label="Customer Email">{order.customer_email ? order.customer_email : '--'}</Descriptions.Item>
                        <Descriptions.Item label="Customer Phone">{order.customer_phone}</Descriptions.Item>
                        <Descriptions.Item label={<span>Transactions<Tooltip title="View payments received against this order.">
                            <Icon style={{ fontSize: 14 }} className="ml-1" type="info-circle" />
                        </Tooltip></span>}>
                                <PermissableButton required_permission="IC_CVA_TRANSACTIONS_READ" type="link" target="_blank" style={{ paddingLeft: 0 }} href={order.is_submerchant?`/insta-collect/orders/${order.merchant_id}/${order.id}/transactions`:`/insta-collect/orders/${order.id}/transactions`}>View Transactions</PermissableButton>
                        </Descriptions.Item>
                    </Descriptions>
                    {virtualAccountObj ?
                        <>
                            <div className="mt-4 d-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center justify-content-between" style={{ marginBottom: '8px' }}>
                                    <Text3 className="d-block"  strong>Account Details</Text3>
                                </div>
                            </div>
                            {renderDetails()}
                        </> : null}
                        <Text3 className="d-block mt-4 mb-2" strong>Additional Details</Text3>
                        <Descriptions title={false} column={1} bordered size="small">
                            <Descriptions.Item label="UDF 1">{order.udf1 || "---"}</Descriptions.Item>
                            <Descriptions.Item label="UDF 2">{order.udf2 || "---"}</Descriptions.Item>
                            <Descriptions.Item label="UDF 3">{order.udf3 || "---"}</Descriptions.Item>
                            <Descriptions.Item label="UDF 4">{order.udf4 || "---"}</Descriptions.Item>
                            <Descriptions.Item label="UDF 5">{order.udf5 || "---"}</Descriptions.Item>
                            <Descriptions.Item label="Allowed Payment Modes">{order.allowed_payment_modes && order.allowed_payment_modes.join(', ') || "---"}</Descriptions.Item>
                           {current_user?.enable_order_soundbox_notifications || order?.notification_settings?.soundbox_ids?
                            <Descriptions.Item label="Soundbox IDs">{order?.notification_settings?.soundbox_ids && order?.notification_settings?.soundbox_ids.join(', ') || "---"}</Descriptions.Item>:null}

                        </Descriptions>
                </div>
            }
        </EaseDrawer>
    )
};

export { OrderDetailsDrawer };